
export enum ShortDriftAchievementType {
  DRIFT = 'DRIFT',
  TIRE_WARMUP = 'TIRE_WARMUP',
  HANDBRAKE = 'HANDBRAKE',
  TURN_180 = 'TURN_180',
}

export interface DriftAchievementGrant {
  type: ShortDriftAchievementType
  grade: number
  basePoints: number
  gradePoints: number
  totalPoints: number
  grantedAtMs: number
}

export interface DriftSessionViewDto {
  sessionId: string
  userId: number
  active: boolean
  startedAtMs: number
  durationMs: number

  clientDriftScore: number
  trickBaseScore: number
  multiplier: number
  trickTotalScore: number
  achievementScore: number
  totalScore: number

  currentAchievementType: ShortDriftAchievementType | null
  currentAchievementGrade: number | null
  turn180Granted: boolean

  achievements: DriftAchievementGrant[]

  pairActive: boolean
  pairUserId: number | null
  bestPairUserId: number | null
  pairBonusScore: number | null
  pairBestStreakMs: number | null
}

export type DriftDto = DriftSessionViewDto

export interface DriftHudProps {
  driftData: DriftDto | null
}

export interface DriftHudState {
  isShown: boolean
  score: number
  scoreToShow: number | string
  footerAnimation: string
  isFinalVisible: boolean
  finalScore: number
  playMultiplierShine: boolean
  achievementTitle: string
  achievementPoints: number
  totalScore: number
  multiplier: number

  isPairActive: boolean
  pairBonusScore: number
  pairStreakSec: number
}

export interface ResolvedHudFrame {
  driftEventType: number
  driftScore: number
  achievementTitle: string
  achievementPoints: number
  multiplier: number
  totalScore: number
  achievementFinalScore: number
  isPairActive: boolean
  pairBonusScore: number
  pairStreakSec: number
}


export const DRIFTEVENTSTART = 0
export const DRIFTEVENTSTOP = 1
export const DRIFTEVENTUPDATE = 2

export const DRIFT_HUD_DEBUG_FEED_EVENT = 'drift-hud:feed'
export const DRIFT_HUD_DEBUG_CLEAR_EVENT = 'drift-hud:clear'